import { attr, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Font = ApplicationRecord.extend({
  static: {
    jsonapiType: 'fonts',
  },
  attrs: {
    name: attr(),
    fontUrl: attr()
  },
})

export default Font
